// extracted by mini-css-extract-plugin
export default {"root":"style_root__CxM3h","radio":"style_radio__dcnWl","radio__active":"style_radio__active__Cg4cx","dot":"style_dot__AVuXV","dot__active":"style_dot__active__WPkXW"};